import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as L from 'leaflet';
import * as esri from 'esri-leaflet';
import MapPopup from './mappopup';
import MarkerImage from '../img/marker.png';
import MarkerImageGroup from '../img/marker_b.png';
import MarkerImageRed from '../img/marker_red.png';
import MarkerImageFav from '../img/marker_fav.png';
import MarkerShadowImage from '../img/marker-shadow.png';
import MarkerImageCommute from '../img/marker_commute.png';
import MarkerCommuteShadowImage from '../img/marker_commute_shadow.png';
import PropTypes from 'prop-types';
import { getCommuteLocationDriveTime, getDefaultSearchParams,
    GetSectionCustomizationOptions } from '../components/util';
import POIs from '../components/pois';
import 'leaflet'; // Creates a global L namespace.
import 'leaflet.markercluster'; // Attaches L.markerClusterGroup to global L.
import * as searchActions from 'actions/search';


//const SiteCustomizationOptions = GetSiteCustomizationOptions();
const SearchPageCustomizationOptions = GetSectionCustomizationOptions("SearchPageOptions");
const CommonCustomizationOptions = GetSectionCustomizationOptions("CommonOptions");

class EsriLeafletMap extends React.Component {

    static contextTypes = {
        router: PropTypes.object.isRequired
    }

    constructor(props) {
        super(props);
        //debugger;
        var lat = 44.9777;
        var lng = -93.2650;

        if (props.defaultMapLocation) {
            var defLoc = props.defaultMapLocation.split(',');

            if (defLoc && defLoc.length === 2) {
                lat = parseFloat(defLoc[0]);
                lng = parseFloat(defLoc[1]);
            }
        }

        //var minZoom = 6;
        //if (window.sessionStorage.MLSKey.toLocaleLowerCase() === "mlspin") minZoom = 5;

        var maxZoom = 16;
        if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.MaxZoomLevelForMap &&
            parseInt(SearchPageCustomizationOptions.MaxZoomLevelForMap, 10) > 0){
            maxZoom = SearchPageCustomizationOptions.MaxZoomLevelForMap;
        }

        this.state = {
            lat: lat,
            lng: lng,
            zoom: 6,
            //minZoom: minZoom,
            maxZoom: maxZoom,
            mapBounds: null,
            mapObj: null,
            markersLayer: null,
            clustersLayer: null,
            poiLayer: null,
            boundariesLayer: null,
            polygons: [],
            polygonControl: null,
            Drawing: false,
            isMobile: false
        }

        this.highlightMarker = this.highlightMarker.bind(this);
        this.onPolygonClick = this.onPolygonClick.bind(this);
        this.onPolygonHover = this.onPolygonHover.bind(this);
        this.refreshMap = this.refreshMap.bind(this);

        this.registerMouseEvents = this.registerMouseEvents.bind(this);
        this.registerTouchEvents = this.registerTouchEvents.bind(this);
        this.drawFinishPolygon = this.drawFinishPolygon.bind(this);
    }

    mIcon = L.icon({
        iconUrl: MarkerImage,
        shadowUrl: MarkerShadowImage,
        iconSize: [26, 38],
        shadowSize: [22, 30],
        iconAnchor: [12, 37],
        shadowAnchor: [3, 29],
        popupAnchor: [1, -24]
    });
    mOpenIcon = L.icon({
        iconUrl: MarkerImageRed,
        shadowUrl: MarkerShadowImage,
        iconSize: [26, 38],
        shadowSize: [22, 30],
        iconAnchor: [12, 37],
        shadowAnchor: [3, 29],
        popupAnchor: [1, -24]
    });
    mFavIcon = L.icon({
        iconUrl: MarkerImageFav,
        shadowUrl: MarkerShadowImage,
        iconSize: [26, 38],
        shadowSize: [22, 30],
        iconAnchor: [12, 37],
        shadowAnchor: [3, 29],
        popupAnchor: [1, -24]
    });
    mGroupIcon = L.icon({
        iconUrl: MarkerImageGroup,
        shadowUrl: MarkerShadowImage,
        iconSize: [26, 38],
        shadowSize: [22, 30],
        iconAnchor: [12, 37],
        shadowAnchor: [3, 29],
        popupAnchor: [1, -24]
    });
    mCommIcon = L.icon({
        iconUrl: MarkerImageCommute,
        shadowUrl: MarkerCommuteShadowImage,
        iconSize: [35, 67],
        shadowSize: [35, 20],
        iconAnchor: [1, 66],
        shadowAnchor: [2, 19],
        popupAnchor: [1, -24]
    });

    hasClass(element, cls) {
        return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
    }

    hasElement(element, elementId) {
        if (element && element.id === elementId) {
            return true;
        }
        else {
            return false;
        }
    }

    onPolygonHover(event) {
        if (event.type === 'mouseover' && event.target && event.target._tooltip && event.target._tooltip.options) {
            event.target._tooltip.options.permanent = true;
            event.target._tooltip.options.interactive = true;
        }
        if (event.type === 'mouseout' && event.target && event.target._tooltip && event.target._tooltip.options) {
            event.target._tooltip.options.permanent = false;
            event.target._tooltip.options.interactive = false;
        }
    }

    onPolygonClick(event) {
        var self = this;

        //if (event.originalEvent && event.originalEvent.target &&
        //    (self.hasClass(event.originalEvent.target, "tooltip-button") || self.hasClass(event.originalEvent.target, "tooltip-link"))) {

            var currentPolygone = Object.assign(self.state.polygons, []);

            //if (event && event.target && event.target._latlngs && event.target._latlngs.length > 0) {
                if (currentPolygone && currentPolygone.length > 0) {
                    currentPolygone.map((eachPoly, index) => {

                        if (eachPoly.length > 0) {
                            eachPoly.splice((eachPoly.length - 1), 1);
                        }

                        //if (JSON.stringify(eachPoly) === JSON.stringify(event.target._latlngs[0])) {
                            currentPolygone.splice(index, 1);
                            //self.state.mapObj.removeLayer(event.target._latlngs[0]);
                            self.state.mapObj.removeLayer(eachPoly);
                        //}
                        return <div />;
                    });
                }
            //}

            self.setState({ polygons: currentPolygone });

            if (currentPolygone) {
                if (self.props.onMapPolygoneChanged) {
                    self.props.onMapPolygoneChanged(currentPolygone);
                }
            }
        //}
    }

    clearMap() {
        let self = this;

        var localMap = self.state.mapObj;

        if (!localMap) return;

        for (var index in localMap._layers) {
            if (localMap._layers[index]._path !== undefined) {
                try {
                    localMap.removeLayer(localMap._layers[index]);
                }
                catch (e) {
                    console.log("problem with " + e + localMap._layers[index]);
                }
            }
        }
    }

    updateIsMobile = () => {
        this.setState({ isMobile: window.innerWidth < 768});
    }

    componentDidMount() {

        var self = this;
        const position = [this.state.lat, this.state.lng];
        const zoomLevel = this.state.zoom;

        var map = L.map(this.refs.mapRef).setView(position, zoomLevel);
        if(this.state.minZoom) map.setMinZoom(this.state.minZoom);
        if(this.state.maxZoom) map.setMaxZoom(this.state.maxZoom);

        map.createPane('fixed', document.getElementById('map'));
        //Draw button----
        L.Control.PolygonTool = L.Control.extend({
            onAdd: function (map) {
                // var container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom leaflet-draw-toolbar leaflet_icon_draw');                
                var container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet_icon_draw');

                container.style.backgroundColor = 'white';
                container.style.width = '30px';
                container.style.height = '30px';
                container.style.cursor = 'pointer';
                container.style.textAlign = 'center';
                container.style.lineHeight = '27px';
                container.id = 'AddPolygon';
                container.title = 'Draw an area';

                container.onclick = function (e) {
                    
                    var isDrawing = !self.state.Drawing;

                    if (isDrawing) {
                        if (self.state.polygons && self.state.polygons.length > 0) {
                            self.onPolygonClick(e);
                        }
                        else{
                            map.dragging.disable();
                            L.DomUtil.addClass(map._container, 'crosshair-cursor-enabled');
                            container.style.backgroundColor = '#cccccc';
                            //container.style.backgroundColor = 'white';
                            container.title = "Cancel draw";
                            self.setState({ Drawing: true });
                        }
                    }
                    else {
                        map.dragging.enable();
                        L.DomUtil.removeClass(map._container, 'crosshair-cursor-enabled');
                        container.style.backgroundColor = 'white';
                        container.title = 'Draw an area';
                        self.setState({ Drawing: false });                        
                    }
                }

                self.setState({ polygonControl: container });
                return container;
            },

            onRemove: function (map) {
                // Nothing to do here
            }
        });

        L.control.PolygonTool = function (opts) { return new L.Control.PolygonTool(opts); }
        L.control.PolygonTool({ position: 'topleft' }).addTo(map);
        //----

        //var streetsLayer = esri.basemapLayer("Streets").addTo(map);
        var streetsLayer = esri.basemapLayer("Streets");
        //var grayLayer = esri.basemapLayer("Gray");
        var grayLayer = L.layerGroup();
        esri.basemapLayer("Gray").addTo(grayLayer);
        esri.basemapLayer("GrayLabels").addTo(grayLayer);
        var topoLayer = esri.basemapLayer("Topographic");
        var darkGrayLayer = esri.basemapLayer("DarkGray");
        var nationalGeographicLayer = esri.basemapLayer("NationalGeographic");
        var oceansLayer = esri.basemapLayer("Oceans");
        var imageryLayer = esri.basemapLayer("Imagery");

        var baseMaps = {
            "Gray Scale": grayLayer,
            "Streets": streetsLayer,
            "Topographic": topoLayer,            
            "Dark Gray": darkGrayLayer,
            "National Geographic": nationalGeographicLayer,
            "Oceans": oceansLayer,
            "Imagery": imageryLayer
        };
        var lyrGroup = L.markerClusterGroup({
            iconCreateFunction: function (cluster) {
                var children = cluster.getAllChildMarkers();
                
                if (children.length === 1 && children[0].options && children[0].options.property && children[0].options.isGroup)
                    return self.mGroupIcon;

                if (children.length === 1 && children[0].options && children[0].options.property)
                    return self.mIcon;
                
                if (children.length === 1 && children[0].options && children[0].options.isCommute)
                    return self.mCommIcon;

                var count = 0;
                for (var i = 0; i < children.length; i++) {
                    if (children[i].options.docCount)
                        count += children[i].options.docCount;
                    else
                        count++;
                }
                //console.log('children in cluster: ' + children.length + ', count: ' + count);
                return L.divIcon({ html: '<div class="clusterMarker"><div class="clusterCount">' + Math.ceil(count) + '</div><div class="clusterMarkerBackground size_' + Math.ceil(count).toString().length + '"></div></div>' });
            },
            showCoverageOnHover: false,
            singleMarkerMode: true,
            disableClusteringAtZoom: 15,
            spiderfyOnMaxZoom: false
        });

        var shownLayer, polygon;

        function removePolygon() {
            if (shownLayer) {
                //shownLayer.setOpacity(1);
                shownLayer = null;
            }
            if (polygon) {
                map.removeLayer(polygon);
                polygon = null;
            }
        };

        function rotate_point(pointX, pointY, originX, originY, angle) {
            angle = angle * Math.PI / 180.0;
            return {
                lat: Math.cos(angle) * (pointX - originX) - Math.sin(angle) * (pointY - originY) + originX,
                lon: Math.sin(angle) * (pointX - originX) + Math.cos(angle) * (pointY - originY) + originY
            };
        }

        var layerPolygon = {};
        lyrGroup.on('clustermouseover', function (a) {
            removePolygon();

            //a.layer.setOpacity(0.2);
            shownLayer = a.layer;
            polygon = L.polygon(a.layer.getConvexHull());
            if (a.layer.getConvexHull().length <= 3) {
                if (layerPolygon[a.layer._leaflet_id]) // do we already have polygon for cluster?
                    polygon = layerPolygon[a.layer._leaflet_id];
                else {
                    var bounds = a.layer.getBounds();
                    var centerLat = bounds.getCenter().lat;
                    var centerLon = bounds.getCenter().lng;
                    var min = 1;
                    var max = 89;
                    var meters;
                    if (map.getZoom() < 11)
                        meters = 4 * ((10 + (1 - map.getZoom())) * 1000);
                    else
                        meters = ((15 - map.getZoom()) * 400);
                    //console.log(map.getZoom() + ' meters: ' + meters);
                    bounds = L.latLng(centerLat, centerLon).toBounds(meters); // this creates shape around center point padded to meters
                    //without rotating we are just creating a box around the cluster, so this rotates each of the points around the center to create random polygon
                    polygon.setLatLngs([
                        L.latLng(rotate_point(bounds._southWest.lat, bounds._southWest.lng, centerLat, centerLon, Math.floor((Math.random() * max) + min))),
                        L.latLng(rotate_point(bounds._southWest.lat, bounds._northEast.lng, centerLat, centerLon, Math.floor((Math.random() * max) + min))),
                        L.latLng(rotate_point(bounds._northEast.lat, bounds._northEast.lng, centerLat, centerLon, Math.floor((Math.random() * max) + min))),
                        L.latLng(rotate_point(bounds._northEast.lat, bounds._southWest.lng, centerLat, centerLon, Math.floor((Math.random() * max) + min)))])//,
                }
            }
            layerPolygon[a.layer._leaflet_id] = polygon;
            map.addLayer(polygon);
        });
        lyrGroup.on('clustermouseout', removePolygon);
        map.on('zoomend', function (a) {
            removePolygon();
            layerPolygon = {};
        });
        var options = { position: 'topleft' };

        /* if (self.props.showStreetView) {
            imageryLayer.addTo(map);
            esri.basemapLayer('ImageryLabels').addTo(map);
        }
        else {
            streetsLayer.addTo(map);
            L.control.layers(baseMaps, null, options).addTo(map);
        } */
        
        grayLayer.addTo(map);
        L.control.layers(baseMaps, null, options).addTo(map);
        

        var lyrBoundaries = L.featureGroup().addTo(map);

        window.sessionStorage.setItem("WatchForZoom", "true");

        map.on('zoomend moveend', function (e) {
            if (window.sessionStorage.getItem("MapZoomSearch") !== null) {
                //Whenever map auto zooms in/out, this function is called twice, 
                //first time with zoomed and second time with moveend event
                if (e && e.type === "moveend") {
                    window.sessionStorage.removeItem("MapZoomSearch");
                }
            }
            else {
                if (window.sessionStorage.getItem("WatchForZoom") === "true") {
                    var bounds = map.getBounds();
                    if (bounds && bounds._southWest && bounds._northEast) {
                        let parameters = Object.assign({}, self.props.searchParameters_Redux);
                        parameters.page_number = 1;
                        var strBounds = bounds._southWest.lng + "," + bounds._southWest.lat +
                            "," + bounds._northEast.lng + "," + bounds._northEast.lat;
                        //console.log('strBounds');
                        //console.log(strBounds);
                        if ((!parameters.mapbound || (parameters.mapbound && parameters.mapbound !== strBounds)) && parameters.searchmap && parameters.searchmap === "true"){
                        //if ((!parameters.mapbound || (parameters.mapbound && parameters.mapbound !== strBounds))){

                            if (parameters.skip) {
                                delete parameters["skip"];
                            }
                            parameters.skip = 0;
                            if (parameters.mapbound) {
                                delete parameters["mapbound"];
                            }
                            if (parameters.geochords) {
                                delete parameters["geochords"];
                            }

                            parameters.mapbound = strBounds;

                            self.props.searchActions.updateParameters(parameters);
                        }
                    }
                }
            }
        });

        /* map.addEventListener('mousedown', function (ev) {
            
            if (!self.state.Drawing) {
                return;
            }

            var currentPolygone = Object.assign(self.state.polygons, []);
            var polygonToDraw = [];
            var searchPolygon = [];

            var myPolygon = null;
            var skip = 0;

            map.addEventListener('mousemove', function (ev) {
                
                skip++;

                if (skip % 3 !== 0) {
                    return;
                }

                polygonToDraw.push([ev.latlng.lat, ev.latlng.lng]);
                searchPolygon.push(ev.latlng);

                if (myPolygon !== null) {
                    map.removeLayer(myPolygon);
                }

                myPolygon = new L.Polygon(polygonToDraw, { 'label': 'label' });
                myPolygon.setStyle({ fillColor: '#53DFF7', color: '#53DFF7' });
                myPolygon.addTo(map);
            });

            currentPolygone.push(searchPolygon);
            self.setState({ polygons: currentPolygone });
        }); */

        /* map.addEventListener('mouseup', function (ev) {
            
            if (!self.state.Drawing) {
                return;
            }

            if (!self.hasElement(ev.originalEvent.target, 'AddPolygon')) {
                map.dragging.enable();
                L.DomUtil.removeClass(map._container, 'crosshair-cursor-enabled');

                var polyControl = Object.assign(self.state.polygonControl, {});

                if (polyControl != null) {
                    polyControl.style.backgroundColor = 'white';
                }

                self.setState({ Drawing: false, polygonControl: polyControl });
            }

            map.removeEventListener('mousemove');

            var polygonToRemove = Object.assign(self.state.polygons, {});

            var needReload = true;

            for (var index = 0; index < polygonToRemove.length; index++) {
                if (polygonToRemove[index].length < 3) {
                    needReload = false;
                    polygonToRemove.splice(index, 1);
                }
            }

            self.setState({ polygons: polygonToRemove });

            if (needReload && self.props.onMapPolygoneChanged) {
                self.props.onMapPolygoneChanged(polygonToRemove);
            }

        }); */

        //if (window.innerWidth <= 1024) {
        if (window.innerWidth < 768) // show normal on ipad
            self.setState({ isMobile: true });

            /* var mapElement = document.getElementById('map');

            var isiOS = /iPad|iPhone|iPod/i.test(navigator.userAgent) && !window.MSStream;

            //Other than iOS device specific code
            if(!isiOS) {

                mapElement.ontouchstart = function (ev) {
                
                    if (!self.state.Drawing) {
                        return;
                    }
    
                    var currentPolygone = Object.assign(self.state.polygons, []);
                    var polygonToDraw = [];
                    var searchPolygon = [];
    
                    var myPolygon = null;
                    var skip = 0;
    
                    mapElement.ontouchmove = function (ev) {
                        ev.preventDefault(); //prevent page scrolling on mobile
                        
                        skip++;
    
                        if (skip % 3 !== 0) {
                            return;
                        }
    
                        if (!ev.changedTouches || ev.changedTouches.length === 0 ||
                            !ev.changedTouches[0] || !ev.changedTouches[0].clientX ||
                            !ev.changedTouches[0].clientY) {
                            return;
                        }
    
                        var rect = map._container.getBoundingClientRect(),
                            lat = ev.changedTouches[0].clientX - rect.left - map._container.clientLeft,
                            lng = ev.changedTouches[0].clientY - rect.top - map._container.clientTop,
                            containerPoint = L.point(lat, lng),
                            layerPoint = map.containerPointToLayerPoint(containerPoint),
                            latlng = map.layerPointToLatLng(layerPoint);
    
                        polygonToDraw.push([latlng.lat, latlng.lng]);
                        searchPolygon.push(latlng);
    
                        if (myPolygon !== null) {
                            map.removeLayer(myPolygon);
                        }
    
                        myPolygon = new L.Polygon(polygonToDraw, { 'label': 'label' });
                        myPolygon.setStyle({ fillColor: '#53DFF7', color: '#53DFF7' });
                        myPolygon.addTo(map);
                    };
    
                    currentPolygone.push(searchPolygon);
                    self.setState({ polygons: currentPolygone });
    
                };
    
                mapElement.ontouchend = function (ev) {
                    
                    if (!self.state.Drawing) {
                        return;
                    }
    
                    if(!self.hasElement(ev.srcElement, 'AddPolygon')) {
                        map.dragging.enable();
                        L.DomUtil.removeClass(map._container, 'crosshair-cursor-enabled');
    
                        var polyControl = Object.assign(self.state.polygonControl, {});
    
                        if (polyControl != null) {
                            polyControl.style.backgroundColor = 'white';
                        }
    
                        self.setState({ Drawing: false, polygonControl: polyControl });
                    }
    
                    mapElement.ontouchmove = () => {};
    
                    var polygonToRemove = Object.assign(self.state.polygons, {});
    
                    var needReload = true;
    
                    for (var index = 0; index < polygonToRemove.length; index++) {
                        if (polygonToRemove[index].length < 3) {
                            needReload = false;
                            polygonToRemove.splice(index, 1);
                        }
                    }
    
                    self.setState({ polygons: polygonToRemove });
    
                    if (needReload && self.props.onMapPolygoneChanged) {
                        self.props.onMapPolygoneChanged(polygonToRemove);
                    }
                };
            }            
            else { //iOS device specific code
                
                var currentPolygone = [];
                var polygonToDraw = [];
                var searchPolygon = [];

                var myPolygon = null;
                var skip = 0;

                function handleOnTouchStart (ev) {
                
                    if (!self.state.Drawing) {
                        return;
                    }
    
                    currentPolygone = Object.assign(self.state.polygons, []);
                    polygonToDraw = [];
                    searchPolygon = [];
    
                    myPolygon = null;
                    skip = 0;
    
                    mapElement.addEventListener('ontouchmove', handleOnTouchMove, false);
    
                    currentPolygone.push(searchPolygon);
                    self.setState({ polygons: currentPolygone });
    
                };

                function handleOnTouchMove (ev) {
                    ev.preventDefault(); //prevent page scrolling on mobile
                    
                    skip++;

                    if (skip % 3 !== 0) {
                        return;
                    }

                    if (!ev.changedTouches || ev.changedTouches.length === 0 ||
                        !ev.changedTouches[0] || !ev.changedTouches[0].clientX ||
                        !ev.changedTouches[0].clientY) {
                        return;
                    }

                    var rect = map._container.getBoundingClientRect(),
                        lat = ev.changedTouches[0].clientX - rect.left - map._container.clientLeft,
                        lng = ev.changedTouches[0].clientY - rect.top - map._container.clientTop,
                        containerPoint = L.point(lat, lng),
                        layerPoint = map.containerPointToLayerPoint(containerPoint),
                        latlng = map.layerPointToLatLng(layerPoint);

                    polygonToDraw.push([latlng.lat, latlng.lng]);
                    searchPolygon.push(latlng);

                    if (myPolygon !== null) {
                        map.removeLayer(myPolygon);
                    }

                    myPolygon = new L.Polygon(polygonToDraw, { 'label': 'label' });
                    myPolygon.setStyle({ fillColor: '#53DFF7', color: '#53DFF7' });
                    myPolygon.addTo(map);
                };
    
                function handleOnTouchEnd (ev) {
                    
                    if (!self.state.Drawing) {
                        return;
                    }
    
                    if(!self.hasElement(ev.srcElement, 'AddPolygon')) {
                        map.dragging.enable();
                        L.DomUtil.removeClass(map._container, 'crosshair-cursor-enabled');
    
                        var polyControl = Object.assign(self.state.polygonControl, {});
    
                        if (polyControl != null) {
                            polyControl.style.backgroundColor = 'white';
                        }
    
                        self.setState({ Drawing: false, polygonControl: polyControl });
                    }
    
                    mapElement.removeEventListener('ontouchmove', handleOnTouchMove, false);
    
                    var polygonToRemove = Object.assign(self.state.polygons, {});
    
                    var needReload = true;
    
                    for (var index = 0; index < polygonToRemove.length; index++) {
                        if (polygonToRemove[index].length < 3) {
                            needReload = false;
                            polygonToRemove.splice(index, 1);
                        }
                    }
    
                    self.setState({ polygons: polygonToRemove });
    
                    if (needReload && self.props.onMapPolygoneChanged) {
                        self.props.onMapPolygoneChanged(polygonToRemove);
                    }
                };

                mapElement.addEventListener('ontouchstart', handleOnTouchStart, false);
                mapElement.addEventListener('ontouchend', handleOnTouchEnd, false);
            } */
            //----

            
        //}

        this.registerMouseEvents(map);
        this.registerTouchEvents(map);

        L.control.scale({ metric: false }).addTo(map);

        var poiLayer = L.layerGroup();
        poiLayer.addTo(map);

        var markersGroup = L.featureGroup();

        if (this.refs.mapRef) {
            this.setState({ mapObj: map, markersLayer: markersGroup, clustersLayer: lyrGroup, boundariesLayer: lyrBoundaries, poiLayer: poiLayer });
        }
        window.addEventListener("resize", this.updateIsMobile);
    }

    registerMouseEvents(map) {

        // iOS mobile will register a touch as a mousedown and ontouchstart
        var isiOS = /iPad|iPhone|iPod/i.test(navigator.userAgent) && !window.MSStream;
        if (isiOS)
            return;

        var self = this;
        map.addEventListener('mousedown', function (ev) {
            if (!self.state.Drawing) {
                return;
            }
            // We are currently drawing a polygon
            var currentPolygon = Object.assign(self.state.polygons, []);
            var polygonToDraw = [];
            var searchPolygon = [];
            var myPolygon = null;
            var skip = 0;

            map.addEventListener('mousemove', function (ev) {
                skip++;
                if (skip % 3 !== 0) {
                    return;
                }
                polygonToDraw.push([ev.latlng.lat, ev.latlng.lng]);
                searchPolygon.push(ev.latlng);
                if (myPolygon !== null) {
                    map.removeLayer(myPolygon);
                }
                myPolygon = new L.Polygon(polygonToDraw, { 'label': 'label' });
                //myPolygon.setStyle({ fillColor: '#53DFF7', color: '#53DFF7' });
                myPolygon.setStyle({ fill: false, color: '#53DFF7' });
                myPolygon.addTo(map);
                //self.setState({ leafletPolygon: myPolygon });
                //self.drawAddPoint(self, ev, map, polygonToDraw, searchPolygon, myPolygon, currentPolygon);
            });

            map.addEventListener('mouseup', function (ev) {
                if (!self.state.Drawing) {
                    return;
                }
                map.removeEventListener('mousemove');
                map.removeEventListener('mouseup');
    
                self.drawFinishPolygon(self, ev, map);
                
            });

            currentPolygon.push(searchPolygon);
            self.setState({ polygons: currentPolygon });
        });
    }

    registerTouchEvents(map) {
        var self = this;
        var mapElement = document.getElementById('map');

        mapElement.addEventListener('touchstart', function (ev) {
            if (!self.state.Drawing) {
                return;
            }

            var currentPolygon = Object.assign(self.state.polygons, []);
            var polygonToDraw = [];
            var searchPolygon = [];
            var myPolygon = null;
            var skip = 0;

            mapElement.addEventListener('touchmove', function _touchmove(ev) {
                ev.preventDefault(); // prevent page scrolling on mobile

                skip++;
                if (skip % 3 !== 0) {
                    return;
                }

                if (!ev.changedTouches || ev.changedTouches.length === 0 ||
                    !ev.changedTouches[0] || !ev.changedTouches[0].clientX ||
                    !ev.changedTouches[0].clientY) {
                    return;
                }
                var rect = map._container.getBoundingClientRect(),
                    lat = ev.changedTouches[0].clientX - rect.left - map._container.clientLeft,
                    lng = ev.changedTouches[0].clientY - rect.top - map._container.clientTop,
                    containerPoint = L.point(lat, lng),
                    layerPoint = map.containerPointToLayerPoint(containerPoint),
                    latlng = map.layerPointToLatLng(layerPoint);

                polygonToDraw.push([latlng.lat, latlng.lng]);
                searchPolygon.push(latlng);

                if (myPolygon !== null) {
                    map.removeLayer(myPolygon);
                }

                myPolygon = new L.Polygon(polygonToDraw, { 'label': 'label' });
                //myPolygon.setStyle({ fillColor: '#53DFF7', color: '#53DFF7' });
                myPolygon.setStyle({ fill: false, color: '#53DFF7' });
                myPolygon.addTo(map);
                //self.setState({ leafletPolygon: myPolygon });

                // Store function to state for removal
                if (!self.state.touchFunction)
                    self.setState({ touchFunction: _touchmove});
            });

            currentPolygon.push(searchPolygon);
            self.setState({ polygons: currentPolygon });

            // Handle default Leaflet touch events
            mapElement.addEventListener('touchend', function _touchend(ev) {
                if (!self.state.Drawing) {
                    return;
                }
                mapElement.removeEventListener('touchend', _touchend);
                
                // Remove function from state variable
                mapElement.removeEventListener('touchmove', self.state.touchFunction);
                self.setState({touchFunction: undefined});

                self.drawFinishPolygon(self, ev, map);
            });

        });
    }

    drawFinishPolygon(self, ev, map) {
        if (!self.hasElement(ev.srcElement, 'AddPolygon')) {
            map.dragging.enable();
            L.DomUtil.removeClass(map._container, 'crosshair-cursor-enabled');
            var polyControl = Object.assign(self.state.polygonControl, {});
            if (polyControl != null) {
                polyControl.style.backgroundColor = 'white';
            }
            self.setState({ Drawing: false, polygonControl: polyControl });
        }

        var polygonToRemove = Object.assign(self.state.polygons, {});
        var needReload = true;

        for (var index = 0; index < polygonToRemove.length; index++) {
            if (polygonToRemove[index].length < 3) {
                needReload = false;
                polygonToRemove.splice(index, 1);
            }
        }

        self.setState({ polygons: polygonToRemove });
        if (needReload && self.props.onMapPolygoneChanged) {
            self.props.onMapPolygoneChanged(polygonToRemove);
        }

        //self.updatePolygonParameter(polygonToRemove);
    }

    componentWillUnmount() {
        // Todo don't use Session use the Map
        window.sessionStorage.setItem("WatchForZoom", "false");
        window.removeEventListener("resize", this.updateIsMobile);
    }

    componentWillReceiveProps(nextProps) {
        if (JSON.stringify(nextProps.polygon) !== JSON.stringify(this.props.polygon)) {
            this.setState({ polygons: nextProps.polygon });
        }
    }

    checkExists(propertyId, list) {
        if (propertyId && list && list.length > 0) {
            const obj = list.filter(p => p.ListingId === propertyId);
            if (obj && obj.length > 0 && obj[0].ListingId === propertyId) {
                return true;
            }
        }
        return false;
    }

    getCentroid = function (arr) {
        return arr.reduce(function (x, y) {
            return [x[0] + y[0] / arr.length, x[1] + y[1] / arr.length]
        }, [0, 0])
    }

    addMarkersToMap() {
        var self = this;
        var foundPoints = false;
        var clayers = [];
        var mlayers = [];
        //const audienceType = self.props.audience.type;
        const { clusters, resultsCount } = self.props;
        const PopupWithContext = withContext(MapPopup, this.context);
        //const favList = (self.props.selectedClient && self.props.selectedClient.Favorites) ? self.props.selectedClient.Favorites : [];
        var tooltip = 'click to zoom in';
        var lstCnt = 100;
        if(SearchPageCustomizationOptions && SearchPageCustomizationOptions.MinimumListingsCountForClusters && 
            SearchPageCustomizationOptions.MinimumListingsCountForClusters !== "" &&
            parseInt(SearchPageCustomizationOptions.MinimumListingsCountForClusters, 10) > 0){
            lstCnt = parseInt(SearchPageCustomizationOptions.MinimumListingsCountForClusters, 10);
        }
        if ((self.props.searchParameters_Redux && self.props.searchParameters_Redux.searchmap) &&
            resultsCount >= lstCnt && clusters) {
        //if (resultsCount >= lstCnt && clusters) {
            
            clusters.Buckets.map((cluster, idx) => {
                var cords = cluster.Aggregations.cell.Bounds;
                // we have the top left and bottom corner of cell, get centroid for better accuracy
                var centerPoint;
                if (resultsCount < 1000) {
                    centerPoint = this.getCentroid([[cords.TopLeft.Lon, cords.TopLeft.Lat],
                    [cords.BottomRight.Lon, cords.TopLeft.Lat],
                    [cords.BottomRight.Lon, cords.BottomRight.Lat],
                    [cords.TopLeft.Lon, cords.BottomRight.Lat]]);
                }
                else centerPoint = [cords.TopLeft.Lon, cords.TopLeft.Lat];// for large results don't perfrom centroid calculation just approximate
                // since there was only one marker at this point, this is a hack to get cluster click event working at some zoom levels 
                var centerCopies = [centerPoint, centerPoint, centerPoint]
                for (var i = 0; i < centerCopies.length; i++) {
                    var pMarker = L.marker([centerCopies[i][1], centerCopies[i][0]], {
                        icon: self.mIcon,
                        title: tooltip,
                        riseOnHover: true,
                        docCount: cluster.DocCount / 3
                    });
                    clayers.push(pMarker);
                }
                foundPoints = true;
                return (<div />);
            })

        }
        else {
            // No clusters from API
            var groupMarkers = [];
            self.props.properties.map(function (property, i) {
                if (property && property.LT !== undefined && property.LT !== null &&
                    property.LG !== undefined && property.LG !== null &&
                    property.LT !== 0 && property.LG !== 0) {
                    var tooltip = (property.SA ? property.SA + ', ' : '') + property.CT + ', ' + property.ST + ' ' + property.PC;
                    var markerIcon = self.mIcon;

                    /* if (property.OH !== undefined && property.OH !== null && property.OH.length > 0)
                        markerIcon = self.mOpenIcon;
                    else if ((audienceType !== undefined && audienceType === 'client' && property.IF !== undefined && property.IF) ||
                        (audienceType !== undefined && audienceType === 'agent' && self.checkExists(property.Id, favList)))
                        markerIcon = self.mFavIcon; */

                    var isGroup = false;
                    var isGroupExist = false;   
                    var groupLst = self.props.properties.filter(p => p.LT === property.LT && p.LG === property.LG); 
                    if(groupLst && groupLst.length > 1){
                        var gExist = groupMarkers.filter(g => g.LT === property.LT && g.LG === property.LG);
                        if(gExist && gExist.length > 0){
                            isGroupExist = true;
                        }   
                        else{
                            groupMarkers.push({LT: property.LT, LG: property.LG});
                        }
                        markerIcon = self.mGroupIcon;
                        isGroup = true; 
                        tooltip = groupLst.length + " Units";       
                    }

                    if(!isGroupExist){
                        var pMarker = L.marker([property.LT, property.LG], {
                            icon: markerIcon,
                            title: tooltip,
                            riseOnHover: true,
                            property: property,
                            isGroup: isGroup,
                            groupLst: (groupLst && groupLst.length > 1) ? groupLst : null,
                        })
                        if(self.props.searchParameters_Redux && !self.props.searchParameters_Redux.searchmap){
                            clayers.push(pMarker);
                        }
                        else{
                            mlayers.push(pMarker);
                        }
                        //mlayers.push(pMarker);
                        if (!self.props.doNotShowPopup) {
                            if (!self.state.isMobile) {
                                pMarker.on('click', function (e) {
                                    if (!self.props.searchParameters_Redux.locationtext && !self.props.searchParameters_Redux.mapbound) {
                                        //This variable is used to control the auto zooming of map
                                        window.sessionStorage.setItem("MapZoomSearch", "false");
                                    }
                                    var mLatLng = this.getLatLng();
                                    var mPoint = self.state.mapObj.latLngToContainerPoint(mLatLng);
                                    mPoint.y = mPoint.y - 22;
                                    mPoint.x = mPoint.x + 1;
                                    var pLatLng = self.state.mapObj.containerPointToLatLng(mPoint);
                                    var popup = document.createElement('div');
                                    ReactDOM.render(<PopupWithContext property={this.options.property} groupLst={this.options.groupLst} purlPrefix={self.props.purlPrefix} />, popup);
                                    L.popup().setLatLng(pLatLng).setContent(popup).openOn(self.state.mapObj);
                                });
                            }
                            else { // isMobile is true
                                var popup = document.createElement('div');
                                ReactDOM.render(<PopupWithContext property={pMarker.options.property} groupLst={pMarker.options.groupLst} purlPrefix={self.props.purlPrefix} />, popup);
                                var fixPopup = L.popup({
                                    pane: 'fixed',
                                    className: 'popup-fixed',
                                    autoPan: false,
                                }).setContent(popup);
                                pMarker.bindPopup(fixPopup, { maxWidth : 560 });
                            }
                        }
                    }
                    foundPoints = true;
                }
                return (<div />);
            });
        }
        // Add to state
        if (clayers.length > 0){
            self.state.clustersLayer.addLayers(clayers);
        }
        else if(mlayers.length > 0){       
            mlayers.map(l => self.state.markersLayer.addLayer(l));
        }

        return foundPoints;
    }

    shouldComponentUpdate(nextProps) {
        if (JSON.stringify(this.props.properties) !== JSON.stringify(nextProps.properties) ||
            JSON.stringify(this.props.searchBoundaries) !== JSON.stringify(nextProps.searchBoundaries) ||
            this.props.height !== nextProps.height ||
            this.props.searchParameters_Redux.geochords !== nextProps.searchParameters_Redux.geochords ||
            this.props.searchParameters_Redux.searchmap !== nextProps.searchParameters_Redux.searchmap ||
            this.props.defaultMapLocation !== nextProps.defaultMapLocation) {
            return true;
        }
        return false;
    }

    componentDidUpdate() {
        
        var self = this;

        if (self.state.mapObj) {
            self.state.mapObj.closePopup();
        }

        if (self.state.clustersLayer) {
            self.state.clustersLayer.clearLayers();
        }
        if (self.state.markersLayer) {
            self.state.markersLayer.clearLayers();
        }

        if (self.state.poiLayer) {
            self.state.poiLayer.clearLayers();
        }

        var polyControl = Object.assign(self.state.polygonControl);

        if (polyControl && polyControl !== null) {
            if (self.state.polygons && self.state.polygons.length > 0) {
                //polyControl.style.display = 'none';
                L.DomUtil.removeClass(polyControl, 'leaflet_icon_draw');
                L.DomUtil.addClass(polyControl, 'leaflet_icon_draw_clear');
                polyControl.title = "Remove drawing";
            }
            else {
                //polyControl.style.display = 'block';
                L.DomUtil.removeClass(polyControl, 'leaflet_icon_draw_clear');
                L.DomUtil.addClass(polyControl, 'leaflet_icon_draw');
                polyControl.title = "Draw an area";
            }
        }

        var foundPoints = false;
        if (self.props.properties && self.state.mapObj && self.state.markersLayer && self.state.clustersLayer) {
            //var foundPoints = false;
            foundPoints = this.addMarkersToMap();
            if (foundPoints || self.props.searchParameters_Redux.geochords) {
                self.state.mapObj.addLayer((self.state.clustersLayer.getLayers().length > 0) ? self.state.clustersLayer : self.state.markersLayer);
                //if(self.props.searchInitiator !== "map" && !self.props.mapBounds) {
                if ((self.props.searchBoundaries === undefined ||
                    self.props.searchBoundaries === null ||
                    self.props.searchBoundaries.length === 0)) {// && self.props.searchInitiator !== "map") {
                    if (self.props.searchParameters_Redux.geochords && !self.props.searchParameters_Redux.mapbound) {
                        var split = self.props.searchParameters_Redux.geochords.split(',');
                        var bounds = L.latLng(split[1], split[0]).toBounds(2000); // this creates shape around center point padded to meters
                        var geoBounds = L.latLngBounds(bounds._southWest, bounds._northEast);
                        window.sessionStorage.setItem("MapZoomSearch", "false");
                        self.state.mapObj.fitBounds(geoBounds);
                    }
                    else if (!self.props.searchParameters_Redux.mapbound) {
                        if (self.props.showStreetView) {
                            if (!self.props.searchParameters_Redux.locationtext) {
                                //This variable is used to control the auto zooming of map
                                window.sessionStorage.setItem("MapZoomSearch", "false");
                            }
                            self.state.mapObj.fitBounds((self.state.clustersLayer.getLayers().length > 0) ? self.state.clustersLayer.getBounds() : self.state.markersLayer.getBounds(), { padding: [20, 20] });
                        }
                        else {
                            if (!self.props.searchParameters_Redux.locationtext) {
                                //This variable is used to control the auto zooming of map
                                window.sessionStorage.setItem("MapZoomSearch", "false");
                            }
                            var currSP =  {...self.props.searchParameters_Redux};
                            delete currSP["searchmap"];
                            if(currSP.skip !== undefined && currSP.skip !== null){
                                currSP.skip = currSP.skip.toString();
                            }
                            if(currSP.page_number !== undefined && currSP.page_number !== null){
                                currSP.page_number = currSP.page_number.toString();
                            }
                            if(currSP.propertytype && currSP.propertytype !== "" && !Array.isArray(currSP.propertytype)){
                                currSP.propertytype = currSP.propertytype.split(",");
                            }
                            currSP = JSON.stringify(currSP);
                            var dfSP = {...getDefaultSearchParams()};
                            if(dfSP.skip !== undefined && dfSP.skip !== null){
                                dfSP.skip = dfSP.skip.toString();
                            }
                            if(dfSP.page_number !== undefined && dfSP.page_number !== null){
                                dfSP.page_number = dfSP.page_number.toString();
                            }
                            if(CommonCustomizationOptions && CommonCustomizationOptions.DefaultSearchPropertyTypes && 
                                CommonCustomizationOptions.DefaultSearchPropertyTypes !== ""){
                                    dfSP.propertytype = CommonCustomizationOptions.DefaultSearchPropertyTypes.split(',');
                            }
                            if(dfSP.propertytype && dfSP.propertytype !== "" && !Array.isArray(dfSP.propertytype)){
                                dfSP.propertytype = dfSP.propertytype.split(",");
                            }
                            dfSP = JSON.stringify(dfSP);
                            if((currSP === dfSP) &&
                                SearchPageCustomizationOptions && SearchPageCustomizationOptions.DefaultSearchMapLocation && SearchPageCustomizationOptions.DefaultSearchMapLocation !== ""){
                                //var mpD = ["-79.38720703125001", "42.51867517417283", "-77.96035766601564", "43.15009591190287"];                                
                                var mpD = SearchPageCustomizationOptions.DefaultSearchMapLocation;
                                var corner1D = L.latLng(mpD[1], mpD[0]);
                                var corner2D = L.latLng(mpD[3], mpD[2]);
                                var mpllD = L.latLngBounds(corner1D, corner2D);
                                //This variable is used to control the auto zooming of map
                                window.sessionStorage.setItem("MapZoomSearch", "false");
                                self.state.mapObj.fitBounds(mpllD);
                            }
                            else{
                                self.state.mapObj.fitBounds((self.state.clustersLayer.getLayers().length > 0) ? self.state.clustersLayer.getBounds() : self.state.markersLayer.getBounds());
                            }
                        }
                    }
                    else {
                        var mp = self.props.searchParameters_Redux.mapbound.split(',');
                        if (mp && mp.length === 4) {
                            var corner1 = L.latLng(mp[1], mp[0]);
                            var corner2 = L.latLng(mp[3], mp[2]);
                            var mpll = L.latLngBounds(corner1, corner2);
                            //This variable is used to control the auto zooming of map
                            window.sessionStorage.setItem("MapZoomSearch", "false");
                            //self.state.mapObj.flyToBounds(mpll);
                            self.state.mapObj.fitBounds(mpll);
                        }
                    }
                }
            }
        }
        if (self.state.boundariesLayer) {
            self.state.boundariesLayer.clearLayers();
        }
        if (self.props.properties && self.state.mapObj && self.state.boundariesLayer && self.props.searchBoundaries) {
            var foundBoundaries = false;
            var mapCleared = false;
            self.props.searchBoundaries.map(function (boundary, i) {
                if (boundary) {
                    var tooltip = boundary.BoundaryName;
                    var boundaryType = boundary.Type;

                    //var commMarker = null;
                    if (boundaryType.toLowerCase() === "commute" && boundary.Latitude && boundary.Longitude) {
                        var mCommIcon = L.icon({
                            iconUrl: MarkerImageCommute,
                            shadowUrl: MarkerCommuteShadowImage,
                            iconSize: [35, 67],
                            shadowSize: [35, 20],
                            iconAnchor: [1, 66],
                            shadowAnchor: [2, 19],
                            popupAnchor: [1, -24]
                        });
                        //commMarker = L.marker([boundary.Latitude, boundary.Longitude], {
                        L.marker([boundary.Latitude, boundary.Longitude], {
                            icon: mCommIcon,
                            /* title: tooltip, */
                            riseOnHover: true,
                            isCommute: true
                        }).bindTooltip(getCommuteLocationDriveTime() + ' Mins Commute to ' + tooltip, { offset: L.point({ x: 2, y: -54 }) }).addTo((self.state.clustersLayer.getLayers().length > 0) ? self.state.clustersLayer : self.state.markersLayer);
                    }

                    if (boundary.Multipolygon && boundary.Multipolygon.length > 0) {
                        //var polyArray = [];
                        boundary.Multipolygon.map(function (point, j) {
                            var polyArray = [];

                            point.map(function (dPoint, k) {
                                if (dPoint && dPoint.length === 2) {
                                    polyArray.push([dPoint[1], dPoint[0]]);
                                }
                                return (<div />);
                            });

                            if (!mapCleared) {
                                self.clearMap();
                                mapCleared = true;
                            }

                            if (polyArray && polyArray.length > 0) {
                                var curPolygon = L.polygon(polyArray)
                                    .on('click', self.onPolygonClick)
                                    .on('mouseover', self.onPolygonHover)
                                    .on('mouseout', self.onPolygonHover);

                                switch (boundaryType) {
                                    case 'polygon':
                                        /* var buttonDiv = L.DomUtil.create('div', 'tooltip-button');
                                        buttonDiv.innerHTML = '<div class="tooltip-link"><span class="fa fa-trash" aria-hidden="true"></span> Remove</div>';

                                        var removeTooltip = L.tooltip({
                                            pane: 'popupPane',
                                            opacity: 1
                                        }, curPolygon).setContent(buttonDiv);

                                        curPolygon.bindTooltip(removeTooltip); */

                                        //curPolygon.setStyle({ fillColor: '#3388FF', color: '#3388FF' });
                                        //curPolygon.setStyle({ fillColor: '#53DFF7', color: '#53DFF7' });
                                        curPolygon.setStyle({ fill: false, color: '#53DFF7' });
                                        break;
                                    case 'address':
                                        if (tooltip && tooltip !== '') {
                                            curPolygon.bindTooltip(tooltip);
                                        }
                                        curPolygon.setStyle({ fillColor: '#B2B2B2', color: '#B2B2B2' });
                                        break;
                                    case 'commute':
                                        if (tooltip && tooltip !== '') {
                                        }
                                        curPolygon.setStyle({ fillColor: '#EB431C', color: '#EB431C' });
                                        break;
                                    default:
                                        break;
                                }

                                curPolygon.addTo(self.state.boundariesLayer);
                            }

                            return (<div />);
                        });
                        foundBoundaries = true;
                    }
                }

                return (<div />);
            });
            if (foundBoundaries) {
                //if (self.props.searchInitiator !== "map") {
                if (!self.props.searchParameters_Redux.mapbound) {
                    //self.state.mapObj.flyToBounds(self.state.boundariesLayer.getBounds());
                    if (!self.props.searchParameters_Redux.locationtext) {
                        //This variable is used to control the auto zooming of map
                        window.sessionStorage.setItem("MapZoomSearch", "false");
                    }
                    self.state.mapObj.fitBounds(self.state.boundariesLayer.getBounds());
                }
                else {
                    var bmp = self.props.searchParameters_Redux.mapbound.split(',');
                    //if (mp && mp.length === 5) {
                    if (bmp && bmp.length === 4) {
                        var bcorner1 = L.latLng(bmp[1], bmp[0]);
                        var bcorner2 = L.latLng(bmp[3], bmp[2]);
                        var bmpll = L.latLngBounds(bcorner1, bcorner2);
                        //This variable is used to control the auto zooming of map
                        window.sessionStorage.setItem("MapZoomSearch", "false");
                        //self.state.mapObj.flyToBounds(bmpll);
                        self.state.mapObj.fitBounds(bmpll);
                    }
                }
                //}
            }
        }
    }

    highlightMarker(currentProperty) {
        var self = this;
        /* if (self.state.mapObj && self.state.markersLayer) {
            //L.Marker.stopAllBouncingMarkers();
            self.state.markersLayer.eachLayer(function (marker) {
                if (marker && marker.options && marker.options.property && marker.options.property.Id && marker.options.property.Id === id) {
                    marker.setZIndexOffset(1000);
                }
                else {
                    marker.setZIndexOffset(900);
                }
            });
        } */
        if(!self.state.isMobile && currentProperty && currentProperty.Id && 
            currentProperty.LT !== undefined && currentProperty.LT !== null &&
            currentProperty.LG !== undefined && currentProperty.LG !== null &&
            currentProperty.LT !== 0 && currentProperty.LG !== 0){      

            const PopupWithContext = withContext(MapPopup, self.context);

            var mLatLng = L.latLng(currentProperty.LT, currentProperty.LG);

            if(self.state.mapObj){
                if (self.state.clustersLayer && self.state.clustersLayer.getLayers().length > 0) {
                    self.state.clustersLayer.eachLayer(function (marker) {
                        if (marker && marker.options && marker.options.property && marker.options.property.Id && marker.options.property.Id === currentProperty.Id) {
                            var visibleOne = self.state.clustersLayer.getVisibleParent(marker);
                            if(visibleOne) mLatLng = visibleOne.getLatLng();                        
                        }
                    });
                }
                else if (self.state.markersLayer && self.state.markersLayer.getLayers().length > 0) {
                    self.state.markersLayer.eachLayer(function (marker) {
                        if (marker && marker.options && marker.options.property && marker.options.property.Id && marker.options.property.Id === currentProperty.Id) {
                            mLatLng = marker.getLatLng();
                        }
                    });
                }
            }

            var mPoint = self.state.mapObj.latLngToContainerPoint(mLatLng);
            mPoint.y = mPoint.y - 2;
            mPoint.x = mPoint.x + 1;
            var pLatLng = self.state.mapObj.containerPointToLatLng(mPoint);
            var popup = document.createElement('div');
            ReactDOM.render(<PopupWithContext property={currentProperty} groupLst={[]} purlPrefix={self.props.purlPrefix} />, popup);
            L.popup().setLatLng(pLatLng).setContent(popup).openOn(self.state.mapObj);

        }

    }

    playdownMarker(id) {
        //L.Marker.stopAllBouncingMarkers();
    }

    refreshMap() {
        if (this.state.mapObj) { this.state.mapObj.invalidateSize() };
    }

    poiChanged = (poiList) => {
        var self = this;
        if (self.state.poiLayer) {
            self.state.poiLayer.clearLayers();
            if(poiList && poiList.length > 0){                
                poiList.map((poi,idx) => {
                    if(poi && poi.Latitude && poi.Longitude){
                        var pTtip = `${poi.Name} (${poi.StreetAddress}, ${poi.City} - ${poi.PostalCode} [Tel: ${poi.Tel}])`;
                        var poiMarker = L.marker([poi.Latitude, poi.Longitude], {
                            icon: L.icon({
                                iconUrl: require('../img/pois/orange/poi-' + poi.Type.replace(/ /g, '').replace(/-/g, '').toLowerCase() + '.png'),
                                shadowUrl: MarkerShadowImage,
                                iconSize: [26, 38],
                                shadowSize: [22, 30],
                                iconAnchor: [12, 37],
                                shadowAnchor: [3, 29],
                                popupAnchor: [1, -24]
                            }),
                            title: pTtip,
                            riseOnHover: true,
                        });
                        poiMarker.on('click', function (e) {
                            var mLatLng = this.getLatLng();
                            var mPoint = self.state.mapObj.latLngToContainerPoint(mLatLng);
                            mPoint.y = mPoint.y - 32;
                            mPoint.x = mPoint.x + 16;
                            var pLatLng = self.state.mapObj.containerPointToLatLng(mPoint);
                            var popup = document.createElement('div');
                            ReactDOM.render(<div className="poi_tooltip"><div style={{fontWeight: "bold"}}>{poi.Name}</div><div>{poi.StreetAddress + ', ' + poi.City + ' - ' + poi.PostalCode}</div><div><a href={"tel:" + poi.Tel} alt="">{poi.Tel}</a></div></div>, popup);
                            L.popup().setLatLng(pLatLng).setContent(popup).openOn(self.state.mapObj);
                        });
                        poiMarker.addTo(self.state.poiLayer);
                    }
                    return null;
                });    
            }
        }        
    }

    render() {

        var mapHeight = (this.props.height) ? { height: this.props.height } : {};

        return (
            <div>
                <div id="map" ref="mapRef" className="map-company" style={mapHeight}></div>
                {SearchPageCustomizationOptions && SearchPageCustomizationOptions.ShowPOIFilterOnMap &&
                <POIs 
                    propId={(this.props.properties && this.props.properties.length > 0 && this.props.properties[0].Id) ? this.props.properties[0].Id : null} 
                    height={this.props.height} 
                    poiChanged={this.poiChanged} />
                }
            </div>
        )
    }
}

function withContext(WrappedComponent, context) {
    class ContextProvider extends React.Component {
        getChildContext() {
            return context;
        }
        render() {
            return <WrappedComponent {...this.props} />
        }
    }
    ContextProvider.childContextTypes = {};
    Object.keys(context).forEach(key => {
        ContextProvider.childContextTypes[key] = PropTypes.any.isRequired;
    });
    return ContextProvider;
}


const mapStateToProps = (state, props) => ({
    searchParameters_Redux: state.search.parameters,
    purlPrefix: state.session.purlPrefix || { url: ''}
});

const mapDispatchToProps = dispatch => ({
    searchActions: bindActionCreators(searchActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(EsriLeafletMap);
